import compact from 'lodash/compact';

import { ContentLessonRef } from '@/models/Unit';
import toBookHref from '@/utils/lesson/toBookHref';
import { CourseRoute, ROUTES } from '@/utils/routes';

export type UnitShortcutType = 'flashcards' | 'materials' | 'resources';

export type UnitShortcut = {
  type: UnitShortcutType;
  href?: string;
  count?: number;
};

export type UnitShortcutsSource = {
  contentLesson: ContentLessonRef;
  hasFlashcards: boolean;
  pendingFlashcards: number;
};

export default function toUnitShortcuts(
  { contentLesson, hasFlashcards, pendingFlashcards }: UnitShortcutsSource,
  { slug, klassId }: CourseRoute,
): UnitShortcut[] {
  const route = { slug, klassId, lessonId: contentLesson.id };
  const bookStyle = contentLesson.book?.bookStyle;

  return compact<UnitShortcut>([
    hasFlashcards && {
      type: 'flashcards',
      ...(pendingFlashcards > 0 && { count: pendingFlashcards }),
    },
    bookStyle && { type: 'materials', href: toBookHref(route, bookStyle) },
    contentLesson.hasResources && {
      type: 'resources',
      href: ROUTES.COURSES.LESSON.RESOURCES(route),
    },
  ]);
}
